import React from 'react'
import BaseButton from './BaseButton'

function SecondaryButton(props) {
  return (
    <BaseButton
      {...props}
      className={`text-white bg-secondary border-secondary hover:bg-secondary-dark hover:border-secondary-dark`}
    />
  )
}

export default SecondaryButton
